<div class="empty-state">
    <img [src]="image">
    <h1 class="accent">{{ text }}</h1>
    <h1 class="accent" *ngIf="text2">{{ text2 }}</h1>
    <ng-content>

    </ng-content>
</div>
